import { AppInitializer } from "@/components/navigation/app-initializer";
import { BrowserRouter } from "react-router";
import { AppRoutes } from "./components/navigation/app-routes";
import { Toaster } from "sonner";

function App() {
  const rawBase = import.meta.env.VITE_SELF_BASE_URL || "/";
  const basename = rawBase === "/" ? "/" : rawBase.replace(/\/+$/, "");

  return (
    <>
      <BrowserRouter basename={basename}>
        <Toaster richColors position="top-right" />
        <AppInitializer />
        <AppRoutes />
      </BrowserRouter>
    </>
  );
}

export default App;
